<template>
  <div>

    <center>
      <h1 class="primary--text mt-10 mb-10">
        
        <div id="health-concern">
          <span v-show="!isEdit">{{ health_concern }}</span>

          <v-text-field
            v-show="isEdit" 
            v-model="health_concern"
            placeholder="Chief Complaint"
            label="Chief Complaint"
            class="primary-label text-enlarge"
          >
          </v-text-field>

          <div title="Edit" @click="isEdit = !isEdit" class="case-title-action" v-show="!isEdit" id="case-title-edit">
            <v-icon>mdi-pencil-outline</v-icon>
          </div>

          <div title="Save" @click="isEdit = !isEdit" class="case-title-action" v-show="isEdit" id="case-title-save">
            <v-icon>mdi-check</v-icon>
          </div>
        </div>

        <small>
          <span style="color: #aaa;">Medical Certificate</span> <span style="color: #333;">
            <i>
              <span v-if="medicalCertificateQuantity">(Sent: {{ medicalCertificateQuantity.Sent }}<!--  | Limit: {{ medicalCertificateQuantity.Limit }} -->)</span>
            </i>
          </span>
        </small>
      </h1>
    </center>

    <!-- <CoolLightBox 
      :items="items" 
      :index="index"
      loop
      :useZoomBar="true"
      @close="index = null">
    </CoolLightBox>

    <CoolLightBox 
      :items="current_case_flattened_images" 
      :index="caseHistoryImageIndex"
      loop
      :useZoomBar="true"
      @close="caseHistoryImageIndex = null">
    </CoolLightBox> -->

    <!-- all props & events -->

    <vue-easy-lightbox
      scrollDisabled
      escDisabled
      moveDisabled
      :visible="visible"
      :imgs="items"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>

    <vue-easy-lightbox
      scrollDisabled
      escDisabled
      moveDisabled
      :visible="caseHistoryImagesVisible"
      :imgs="current_case_flattened_images"
      :index="caseHistoryImageIndex"
      @hide="handleCaseHistoryHide"
    ></vue-easy-lightbox>


    <hr >

    <div v-if="items.length > 0">
        <h2 class="mt-5">PMS Case Images<small><br><i><span style="color: red;">Note:</span> Click on an image to enlarge its view</i></small></h2>
        <div class="images-wrapper">
          <div
            class="inline-block"
            v-for="(image, imageIndex) in case_images"
            :key="imageIndex"
          >
            
            <div
              v-show="!image.filename.includes('.pdf')"
              class="image case-image-preview"
              @click="setIndex(imageIndex)"
              :style="{ backgroundImage: 'url(' + image.filelink + ')' }"
            >
              
              <label class="case-image-datetime">{{ image.created_at }}</label>

            </div>

          </div>



        </div>

      <hr >
    </div>

    <div v-if="items.length == 0">
      <h2 class="mt-5">No image available for this case</h2>
      <br>
      <hr >
    </div>

    <div v-if="case_pdfs.length > 0">
      <h2 class="mt-5">PMS PDF Files<small><br><i><span style="color: red;">Note:</span> Click on the icon to view document <small><u>(Hover to get its filename)</u></small></i></small></h2>
      <a v-for="(item, key, index) in case_pdfs" :id="pdf-document-index" :key="key" :href="`${item.filelink}`" target="_blank" class="clickable">
        <img class="pdf-image-ico" src="../../../../../assets/pdf_ico.png" :title="item.filename">
      </a>
      <p>&nbsp;</p>
      <hr />
    </div>

    <h3 class="grey--text text--darken-3 mt-10">Case Information<br><small style="font-style: italic;"><span style="color: red;">Note:</span> All previous Diagnoses, Recommendations and Medications will automatically be removed upon saving the record.</small></h3>
    <br>
    <v-form ref="form" v-model="valid">
      
      <!-- ##################################### REASON FOR ENCOUNTER ##################################### -->
      
      <v-row justify="center">  
        <v-col cols="10" sm="12">
          <v-textarea
            v-model="reason"
            placeholder=" "
            label="Reason for Encounter"
            class="primary-label"
            rows="6"
            row-height="23.7"
            auto-grow
            v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.reason = `${this.reason || ''} ${text}`;}, 'reason')}"
            v-on:click="() => {this.$vtt.setModel('reason');}"
          >
          </v-textarea>
        </v-col>
      </v-row>

      <!-- ##################################### REASON FOR ENCOUNTER ##################################### -->

      <!-- ************************************* SymptomChecker ************************************* -->
      <SymptomChecker />
      <!-- ************************************* SymptomChecker ************************************* -->

      <v-row justify="center">
        <v-col cols="10" sm="12">
          <!-- case category comment -->
          <v-textarea
            v-model="endorsement"
            placeholder=" "
            label="Endorsement"
            class="primary-label"
            rows="3"
            auto-grow
            v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.endorsement = `${this.endorsement || ''} ${text}`;}, 'endorsement')}"
            v-on:click="() => {this.$vtt.setModel('endorsement');}"
            @input="setHint(endorsement, (replacement) => { endorsement = replacement })"
            @keydown.tab="(e) => {
              if (!getReplacement(endorsement)) { return true; } else { e.preventDefault(); endorsement = getReplacement(endorsement); clearReplacement() }
            }"
          >
          </v-textarea>
        </v-col>
      </v-row>

      

      <!-- ##################################### CASE CATEGORY ##################################### -->

      <v-row>
        <!-- category autocomplete -->
        <v-col cols="10" sm="6">
          <v-autocomplete
            v-model="case_category"
            placeholder=" "
            :items="categories"
            @change="hasSelectedPedia = $event == 'Pediatric'"
            :rules="rules.required"
          >
            <template v-slot:append>
              <v-icon>mdi-menu-down</v-icon>
            </template>
            <template v-slot:label>
              <span class="primary--text">Case Category <span class="red--text">*</span></span>
            </template>
          </v-autocomplete>
        </v-col>

        <!-- subcategory autocomplete -->
        <v-col cols="10" sm="6" v-if="case_category == 'Pediatric'" >
          <!-- pediatrics category -->
          <v-autocomplete
            v-model="case_sub_category"
            placeholder=" "
            :items="pediatric_categories"
            class="primary-label"
            :rules="rules.required"
          >
            <template v-slot:append>
              <v-icon>mdi-menu-down</v-icon>
            </template>
            <template v-slot:label>
              <span class="primary--text">Pediatric Category <span class="red--text">*</span></span>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="10" sm="6" v-if="case_category == 'Others'" >
          <!-- case category comment -->
          <v-text-field
            v-if="case_category == 'Others'" 
            v-model="caseCategoryComments"
            placeholder=" "
            label="Case Category Comment"
            class="primary-label"
            v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.caseCategoryComments = `${this.caseCategoryComments || ''} ${text}`;}, 'caseCategoryComments')}"
            v-on:click="() => {this.$vtt.setModel('caseCategoryComments');}"
            @input="setHint(caseCategoryComments, (replacement) => { caseCategoryComments = replacement })"
            @keydown.tab="(e) => {
              if (!getReplacement(caseCategoryComments)) { return true; } else { e.preventDefault(); caseCategoryComments = getReplacement(caseCategoryComments); clearReplacement() }
            }"
          >
          </v-text-field>

        </v-col>
      </v-row>

      <!-- ##################################### CASE CATEGORY ##################################### -->

      <v-row>
        <v-col cols="12" sm="12">
          <p>&nbsp;</p>
          <hr />
        </v-col>
      </v-row>

    </v-form>

    <h3 class="grey--text text--darken-3 mt-10 d-flex">
      <span>Case History</span>
      <!-- <base-popup-btn
        class="ml-auto"
        @click="addCase"
      >
        Add case
      </base-popup-btn> -->
    </h3>
    
    <v-row align="center">
      <v-col cols="12">
        <base-table
          :headers="headers"
          :items="patientCases"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td>{{ item.health_concern }}</td>
              <td>{{ item.case_number }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.impression }}</td>
              <td>

                <div v-if="item.latest_request != null">
                  <span v-show="item.latest_request.has_medical_certificate">
                    <a target="_blank" :href="item.latest_request.file_medical_certificate">VIEW</a>
                  </span>
                </div>

                <span v-show="item.latest_request && !item.latest_request.has_medical_certificate">
                  Not Available
                </span>

              </td>
              <td>
                
                <div v-if="item.latest_request != null">
                  <span v-show="item.latest_request && item.latest_request.has_medical_certificate && item.latest_request.rest_days">
                    {{ item.latest_request.rest_days }}
                  </span>
                </div>

                <span v-show="item.latest_request && !item.latest_request.has_medical_certificate">
                  Not Available
                </span>

              </td>
              <td>{{ item.physician }}</td>
              <td>
                <div v-bind:id="'case_history_instance-' + index" @click="viewCase(index, item.case_number, item.id)" class="blue-button">View History</div>
              </td>
            </tr>
          </template>
        </base-table>

        <p>&nbsp;</p>
        <hr />

      </v-col>
    </v-row>

    <!-- ADD CASE DIALOG -->
    <v-dialog
     v-model="addCaseDialog"
     content-class="elevation-0"
     width="70vw"
     max-width="600px" 
    >
      <v-card>
        <v-card-title class="primary--text">Case</v-card-title>
        
        <v-card-text>
          <!-- Case title -->
          <v-text-field v-model="title" placeholder=" ">
            <template v-slot:label>
              <h3>Title</h3>
            </template>
          </v-text-field>

          <!-- Impression text -->
          <v-text-field v-model="impression" placeholder=" ">
            <template v-slot:label>
              <h3>Impression</h3>
            </template>
          </v-text-field>

          <!-- Physician text -->
          <v-text-field v-model="physician" placeholder=" ">
            <template v-slot:label>
              <h3>Physician</h3>
            </template>
          </v-text-field>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="d-flex justify-center">
          <!-- Add/ Update Button -->
          <v-btn
            rounded
            small
            color="primary"
            class="px-6 mx-2"
            @click="saveCase"
          >
            {{ caseUpdate?'Update':'Add' }}
          </v-btn>

          <!-- Remove Button -->
          <v-btn
            rounded
            small
            color="error"
            class="px-6 mx-2"
            v-if="caseUpdate"
            @click="removeCase"
          >Remove</v-btn>

          <!-- Cancel Button -->
          <v-btn
            rounded
            small
            color="primary lighten-5"
            class="px-6 mx-2 primary--text"
            @click="cancelCase"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CASE INFO DIALOG -->
    <v-dialog
      id="case_info_history_dialog"
      v-model="caseDialog"
      content-class="elevation-0"
      max-width="800"
    >
      <v-card
        id="case_info_history_view"
        height="87vh"
        max-height="600px"
        style="overflow-x: hidden;"
      >
        <!-- header -->
        <v-card-title id="case_info_history_title">
          <v-row align="center">
            <v-col class="py-0">
              <h3 :id="currentCase.id" class="primary--text">Case No. {{ currentCase.case_number }}</h3>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-btn icon class="float-right" @click="caseDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        
        <v-card-text id="case_info_history_dialog" class="overflow-y-auto" style="height:80%; overflow-x: hidden;">
          <v-row>
            <v-col cols="12" class="pb-0 black--text"><h2>Case Images<small><br><i><span style="color: red;">Note:</span> Click on an image to enlarge its view</i></small></h2></v-col>
            <v-col cols="12" class="pb-0 black--text">
              <div class="images-wrapper case-history">
                <div
                  id="case_info_history_images"
                  v-for="(image, imageIndex) in currentCase.case_images"
                  :key="imageIndex"
                  class="inline-block"
                >
                  <div
                    id="case_info_history_pdfs"
                    v-if="!image.filename.includes('.pdf')"
                    class="image"
                    @click="setCaseHistoryImageIndex(imageIndex)"
                    :style="{ backgroundImage: 'url(' + image.filelink + ')' }">  
                  </div>
                </div>

                <div v-show="currentCase.case_pdfs.length">
                  <hr />

                  <v-row>
                    <v-col cols="12" class="pb-0 black--text"><h2>Case PDFs<small><br><i><span style="color: red;">Note:</span> Click the icon to view attached PDFs</i></small></h2></v-col>       
                    <v-col cols="12" class="pb-0 black--text">
                      <a v-for="(item, pdfIndex) in currentCase.case_pdfs" :key="pdfIndex" :href="item.filelink" target="_blank" class="clickable">
                        <img class="pdf-image-ico" src="../../../../../assets/pdf_ico.png" :title="item.filename">
                      </a>
                    </v-col>
                  </v-row>

                </div>
              </div>
            </v-col>

            <v-col cols="12" v-if="currentCase.case_images_pulled == true && currentCase.case_images.length == 0"> 
              <span>No data available</span>
            </v-col>

            <v-col cols="12" v-if="case_history_image_loading"> 
              <span>Please wait while case images are being pulled...</span>
            </v-col>

            <v-col cols="12"> 
              <hr />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <div>Title: <span class="font-weight-bold">{{ currentCase.health_concern }}</span></div>
              <div>Date: <span class="font-weight-bold">{{ currentCase.created_at }}</span></div>
              <div>Impression: <span class="font-weight-bold">{{ currentCase.impression }}</span></div>
            </v-col>
            <v-col cols="6">
              <div>Case Category: <span class="font-weight-bold">{{ currentCase.case_category }}</span></div>
              <div>Physician: <span class="font-weight-bold">{{ currentCase.physician }}</span></div>
              <div>
                Is Seasonal Illness: <span class="font-weight-bold">{{ (currentCase.isSeasonalIllness == 1) ? 'Yes' :'No' }}</span>
              </div>
            </v-col>
          </v-row>

          <hr />

          <v-col cols="12" class="pb-0 mt-5 black--text">
            <h3>Documents</h3>

            <div v-if="currentCase.latest_request">
              
              <ul>
                <li v-if="currentCase.latest_request.file_prescription != null">
                  <a target="_blank" :href="currentCase.latest_request.file_prescription">Prescription</a>
                </li>

                <li v-if="currentCase.latest_request.file_careplan != null">
                  <a target="_blank" :href="currentCase.latest_request.file_careplan">CMT</a>
                </li>

                <li v-if="currentCase.latest_request.file_laboratory != null">
                  <a target="_blank" :href="currentCase.latest_request.file_laboratory">Laboratory Request</a>
                </li>

                <li v-if="currentCase.latest_request && currentCase.latest_request.file_medical_certificate != null">
                  <a target="_blank" :href="currentCase.latest_request.file_medical_certificate">Medical Certificate</a>
                </li>
              </ul>

              <div v-if="!currentCase.latest_request.medical_certificare && !currentCase.latest_request.file_laboratory && !currentCase.latest_request.file_careplan && !currentCase.latest_request.file_prescription">
                <span style="color: rgba(0, 0, 0, 0.6);">No data available</span>
              </div>

              <p>&nbsp;</p>

              <div v-if="currentCase.latest_request.laboratory_tests.length > 0">
                <h3>Laboratory Requests</h3>
                <ul>
                  <li v-for="(item, index) in currentCase.latest_request.laboratory_tests" :key="index">
                    {{ item }}
                  </li>
                </ul>
              </div>

              <p>&nbsp;</p>
              
              <div v-if="currentCase.latest_request.other_tests != null">
                <h3>Other tests:</h3>
                <p>{{ currentCase.latest_request.other_tests }}</p>
              </div>
            </div>
          </v-col>

          <hr />

          <v-row>
            <v-col cols="12">
              <v-col cols="12" class="pb-0 black--text"><h3>History Of Present Illness</h3></v-col>
              <v-col cols="12" class="pb-0 black--text">                
                <div v-html="currentCase.historyOfPresentIllness"></div>
              </v-col>
            </v-col>
          </v-row>

          <hr />

          <v-row>
            <!-- Review of Systems -->
            <v-col cols="12" class="pb-0 black--text"><h3>Review of Systems</h3></v-col>
            <v-col
              cols="12"
              v-if="currentCase.total_examinations < 1"
            > 
              <span>No data available</span>
            </v-col>
            <v-col
              v-else
              cols="12"
            >
              
              <v-row>
                <v-col cols="12" v-for="(examination,key) in currentCase.examinations" :key="key">
                  <div class="pa-2 v-card v-sheet v-sheet--outlined theme--light rounded-0">
                    <span class="capitalize caption-text font-weight-bold">{{ examination.name }}</span>
                    
                    <div class="main-text mb-3">
                      <span v-for="(instance,key) in examination.sub_name" :key="key">
                        <span v-if="instance.value >= 0 && instance.value">    

                          {{ instance.name }} - 
                          <strong>
                            <span v-if="instance.value == 1">Yes</span>
                            <span v-if="instance.value == 2">No</span>
                          </strong>
                          <br v-if="key+1 !== examination.sub_name.length" />

                        </span>
                      </span>
                    </div>
                    
                    <p v-if="examination.note">
                      <strong>Remarks:</strong> {{ examination.note }}
                    </p>

                  </div>
                </v-col>
              </v-row>

              <br />
              <hr />

            </v-col>

            <!-- Diagnoses -->
            <v-col cols="12" class="pb-0 mt-5 black--text"><h3>Diagnosis</h3></v-col>
            <v-col cols="6" v-for="diagnosis in currentCase.diagnoses" :id="diagnosis.id" :key="diagnosis.medical_code">
              <v-card tile outlined class="pa-2">
                <h3>{{ diagnosis.medical_code }}</h3>
                <div>{{ diagnosis.short_description }}</div>
                <div><b>Impression: </b>{{ diagnosis.impression }}</div>
              </v-card>
            </v-col>
            
            <v-col cols="12"> 
              <span v-if="currentCase.total_diagnoses < 1">No data available</span>

              <p>&nbsp;</p>
              <hr />
            </v-col>

            <!-- Medicines -->
            <v-col cols="12" class="pb-0 black--text"><h3>Medicines</h3></v-col>
            <v-col cols="6" v-for="(medicine, key) in currentCase.medicines" :key="key">
              <v-card tile outlined class="pa-2">
                <h3>{{ medicine.brand_name }}</h3>
                <p>{{ medicine.generic_name }}</p>
                <div><b>Strength⁄Preparation: </b>{{ medicine.strength }}</div>
                <div><b>Quantity: </b>{{ medicine.quantity }}</div>
                <div v-if="medicine.instruction">
                  <b>Instruction: </b>
                  <span v-if="JSON.parse(medicine.instruction).sentence">
                    {{ JSON.parse(medicine.instruction).sentence }}
                  </span>
                  <span v-else>
                    Take {{ JSON.parse(medicine.instruction).take.quantity + ' ' + JSON.parse(medicine.instruction).take.label }}&nbsp;
                    every {{ JSON.parse(medicine.instruction).every.quantity + ' ' + JSON.parse(medicine.instruction).every.label }}&nbsp;
                    for {{ JSON.parse(medicine.instruction).for.quantity + ' ' + JSON.parse(medicine.instruction).for.label }}
                  </span>
                </div>
                <!-- <div><b>Comment: </b>{{ medicine.instruction.comment }}</div> -->
              </v-card>
            </v-col>
            <v-col cols="12"> 
              <span v-if="currentCase.total_medicines < 1">No data available</span>

              <p>&nbsp;</p>
              <hr />
            </v-col>

            <!-- Recommendation -->
            <v-col cols="12" class="pb-0 black--text"><h3>Recommendation</h3></v-col>
            <v-col
              cols="12"
              v-if="currentCase.total_recommendations"
              class="py-0"
            >
              
              <table class="mt-5" style="width: 100%;">
                <thead>
                  <tr class="text-left">
                    <th>Point of Care</th>
                    <th>Time to Treat</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(recommendation, key) in currentCase.recommendations" :key="key">
                    <td>{{ recommendation.point_of_care }}</td>
                    <td>{{ recommendation.time_to_treat }}</td>
                    <td width="60%">
                      <div v-html="recommendation.recommended_action"></div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <p>&nbsp;</p>
              <hr />
            </v-col>
            <v-col v-else cols="12"> 
              <span>No data available</span>
            </v-col>

            <!-- Notes -->
            <v-col cols="12" class="pb-0 mt-10 black--text"><h3>Notes</h3></v-col>
            <v-col
              cols="12"
              v-if="currentCase.total_notes"
              class="py-0"
            >
              <table
                class="mt-5 table table-striped"
                style="width: 100%;"
                cellspacing="5"
              >
                <tr class="text-left">
                  <th>Title</th>
                  <th>Note</th>
                </tr>
                <tr v-for="(note, key) in currentCase.notes" :key="key">
                  <td width="30%">{{ note.title }}</td>
                  <td>{{ note.note }}</td>
                </tr>
              </table>
            </v-col>
            <v-col v-else cols="12"> 
              <span v-if="currentCase.total_notes < 1">No data available</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            rounded
            depressed
            color="grey"
            dark
            width="100px"
            @click="caseDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  import textreplacementmixin from '../../../../../mixins/textreplacementmixin';
  Vue.use(Viewer)

  export default {
    name: 'FormCaseInfo',  
    mixins: [textreplacementmixin],
    components: {
      SymptomChecker: () => import('./SymptomChecker.vue')
    },
    data: ()=> ({
      isEdit: false,
      auth_token: localStorage.getItem("auth_token"),
      VUE_APP_API_URL: process.env.VUE_APP_API_URL,
      items: [],
      index: 0,
      visible: false,
      caseHistoryImagesVisible: false,
      caseHistoryImageIndex: null,
      case_history_image_loading: true,

      rules: {
       required: [value => !!value || "This field is required."]
      },

      valid: false,
      currentCaseModel:{},
      currentCase: {case_images:[], case_pdfs:[]},
      currentIndex: null,
      current_case_flattened_images: [],

      hasSelectedPedia: false,
      caseDialog: false,
      addCaseDialog: false,
      caseUpdate: false,
      patientCases: [],
      case_pdfs: [],
      headers: [
        { text: 'Title', value: 'title', class:'primary--text' },
        { text: 'Case Number', value: 'case_no', class:'primary--text'},
        { text: 'Created On', value: 'created_on', class:'primary--text'},
        { text: 'Impression', value: 'impression', class:'primary--text' },
        { text: 'MedCert', value: 'latest_request.file_medical_certificate', class:'primary--text' },
        { text: 'Rest Days', value: 'latest_request.rest_days', class:'primary--text' },
        { text: 'Physician', value: 'physician', class:'primary--text'},
        { text: 'Action', value: '', class:'primary--text'},
      ],
      categories: [
        "Others",
        "Cardiology",
        "Dental Medicine",
        "Dermatology",
        "Endocrinology",
        "ENT-HNS",
        "Gastroenterology",
        "Gen. Medicine",
        "Gen. Surgery",
        "Hematology",
        "Immunology / Allergology",
        "Infectious Disease",
        "Inquiry",
        "Nephrology",
        "Neurology",
        "OB-Gynecology",
        "Occupational Medicine",
        "Ophthalmology",
        "Orthopaedics",
        "Pediatric",
        "Psychiatry",
        "Pulmonology",
        "Rehab Medicine",
        "Rheumatology",
        "Urology"
      ],
      
      pediatric_categories: [
        "General Pediatrics",
        "Allergology/Immunology",
        "Cardiology",
        "Dentistry",
        "Dermatology",
        "Development",
        "Endocrinology",
        "Ears, Nose and Throat",
        "Gastroenterology",
        "Hematology",
        "Infectious Disease",
        "Nephrology",
        "Neurology",
        "Ophthalmology",
        "Orthopedics",
        "Pulmonology",
        "Surgery"
      ],

      subs: [
        'General/unspecified',
        'Tendocrine, metabolic and nutritional',
        'Female genital system and breast',
        'Blood, blood forming organs, spleen',
        'Pregnancy, childbirth, family planning',
        'Male genital system',
        'Back symptom/complaint',
        'Health maintenance/prevention',
        'Pain general/multiple sites',
        'High blood pressures',
        'Headaches and migraines',
        'Abnormal result investigation',
        'Back syndrome without radiating pain',
        'Throat symptom/complaint',
        'Upper respiratory infection acute'
      ],

      options: {
        button: true,
        navbar: true,
        title: false,
        toolbar: true,
        tooltip: true,
        movable: false,
        zoomable: true,
        rotatable: true,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source'
      },
    }),

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    watch: {
      currentIndex: async function (val) {
        this.currentCase = this.patientCases[val];
        console.log("current_index_change");
        console.log(val);
        console.log("currentCase data");
        console.log(this.currentCase);
        let fff = await this.$store.getters['cases/case'];
        if (fff.case_history[val].latest_request.length > 0) {
          let latest_pdfs = fff.case_history[val].latest_request[0];
          this.currentCase.latest_request.file_prescription = latest_pdfs.file_prescription;
          this.currentCase.latest_request.file_careplan = latest_pdfs.file_careplan;
          this.currentCase.latest_request.file_laboratory = latest_pdfs.file_laboratory;
          this.currentCase.latest_request.file_medical_certificate = latest_pdfs.file_medical_certificate;
        }    
        console.log('latest_request:', this.currentCase.latest_request)
      },

      category(val) {
        if (val == 'Pediatric') {
          this.hasSelectedPedia = true
        }
      },

      formSubmitted(val) {
        if (val) {
          this.$refs.form.validate();
        }
      },

      case_images(instances) {
        this.items = []
        for (var key in instances) {
          this.items.push(instances[key].filelink);
          var fileName = instances[key].filename;
          var fileExtension = fileName.split('.').pop(); //"pdf"

          if(fileExtension == "pdf") {
            this.case_pdfs.push(instances[key]);
          }
        }
      },

      case_history(history_instance) {
        this.format_case_history(history_instance);
      }
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    computed: {

      medicalCertificateQuantity: {
        get() { return this.$store.getters['cases/medicalCertificateQuantity'] },
        set() { this.$store.getters['cases/updateMedicalCertificateQuantity'] }
      },

      formSubmitted() { return this.$store.getters['cases/form_submitted'] },
      case_history() { return this.$store.getters['cases/case_history'] },

      case_images: {
        get() { return this.$store.getters['cases/case_images'] },
        set(val) { this.$store.commit('cases/updateImageList', val) }
      },

      health_concern: {
        get() { return this.$store.getters['cases/health_concern'] },
        set(val) { this.$store.commit('cases/setHealthConcern', val) }
      },

      reason: {
        get() { return this.$store.getters['cases/reason'] },
        set(val) { this.$store.commit('cases/updateReason', val) }
      },

      case_category: {
        get() { return this.$store.getters['cases/case_category'] },
        set(val) { this.$store.commit('cases/updateCategory', val) }
      },

      case_sub_category: {
        get() { return this.$store.getters['cases/case_sub_category'] },
        set(val) { this.$store.commit('cases/updateCaseSubCategory', val) }
      },

      caseCategoryComments: {
        get() { return this.$store.getters['cases/caseCategoryComments'] },
        set(val) { this.$store.commit('cases/updateCaseCategoryComments', val) }
      },

      endorsement: {
        get() { return this.$store.getters['cases/endorsement'] },
        set(val) { this.$store.commit('cases/updateEndorsement', val) }
      },

      sub: {
        get() { return this.$store.getters['cases/sub'] },
        set(val) { this.$store.commit('cases/updateSub', val) }
      },

      title: {
        get() { return this.$store.getters['case/case'] },
        set(val) { this.$store.commit('case/updateCase', val) }
      },
      
      impression: {
        get() { return this.$store.getters['case/impression'] },
        set(val) { this.$store.commit('case/updateImpression', val) }
      },
      
      physician: {
        get() { return this.$store.getters['case/physician'] },
        set(val) { this.$store.commit('case/updatePhysician', val) }
      },
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    async mounted() {
      this.items = [];
      var patient_full_data = this.$store.getters['patient/fullData'];
      console.log("[patient full data]", patient_full_data);
      console.log("[case history]", this.case_history);
      this.format_case_history(this.case_history);
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    methods: {
      handleCaseHistoryHide() {
        this.caseHistoryImagesVisible = false
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      handleHide() {
        this.visible = false
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      setIndex(index) {
        this.index = index;
        this.visible = true;
        console.log(index);
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      setCaseHistoryImageIndex(index) {
        this.caseHistoryImageIndex = index;
        this.caseHistoryImagesVisible = true;
        console.log(index);
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      // function that kicks in upon viewing a case history
      viewCase(index, caseNumber, consultation_id) {

        console.log(this.patientCases);

        // let selIndex = this.patientCases.map(function(e) { return e.case_number; }).indexOf(caseNumber);
        let selIndex = this.patientCases.findIndex( x => x.id === consultation_id );

        let that = this;
        this.currentIndex = selIndex;
        this.caseDialog = true;
        this.case_history_image_loading = true;

        console.log('indexes:', { orig: index, filtered: selIndex, caseNumber, consultation_id });

        // processing the case images based on selected index of case history
        if(!this.patientCases[selIndex].case_images_pulled) {

          that.current_case_flattened_images = [];
          that.current_case_flattened_pdfs = [];
          var case_number = this.patientCases[selIndex].case_number;
          var api_case_images = this.getCaseImages(case_number, selIndex);

          api_case_images.then((result) => {
            console.log("[case images]", result);
            
            if(result) {
              that.patientCases[selIndex].case_images = result.json.case_images;
              that.patientCases[selIndex].case_pdfs = [];

              if(result.json.case_images.length > 0) {
                result.json.case_images.forEach(function (case_history_image_instance) {
                  that.current_case_flattened_images.push(case_history_image_instance.filelink);

                  var currentSelectedCaseImagesfileExtension = case_history_image_instance.filename.split('.').pop(); //"pdf"
                  
                  console.log("[case file filename extension]", currentSelectedCaseImagesfileExtension);

                  if(currentSelectedCaseImagesfileExtension == "pdf") {
                    that.patientCases[selIndex].case_pdfs.push(case_history_image_instance);
                  } else {
                    that.current_case_flattened_images.push(case_history_image_instance.filelink);
                  }

                });
              }

              that.patientCases[selIndex].case_images_pulled = true;
              that.case_history_image_loading = false;
            }

          });

        } else {

          that.patientCases[selIndex].case_pdfs = [];
          that.case_history_image_loading = false;
          that.current_case_flattened_images = [];
          that.current_case_flattened_pdfs = [];        
          if(that.patientCases[selIndex].case_images.length > 0) {
            that.patientCases[selIndex].case_images.forEach(function (case_history_image_instance) {
                          
              var currentSelectedCaseImagesfileExtension = case_history_image_instance.filename.split('.').pop(); //"pdf"
              
              console.log("[case file filename extension]", currentSelectedCaseImagesfileExtension);

              if(currentSelectedCaseImagesfileExtension == "pdf") {
                that.patientCases[selIndex].case_pdfs.push(case_history_image_instance);
              } else {
                that.current_case_flattened_images.push(case_history_image_instance.filelink);
              }

            });
          }
        }
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      async getCaseImages(case_number) {
        // var api_case_images = await this.$store.dispatch('cases/getImages', case_number);
        return await this.$store.dispatch('cases/getImages', case_number);
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      addCase() {
        this.$store.commit('case/clear');
        this.addCaseDialog = true;
        this.caseUpdate = false;
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      updateCase(index) {
        this.addCaseDialog = true;
        this.caseUpdate = true;
        this.$store.commit('case/setActive', index);
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      cancelCase() {
        this.addCaseDialog = false;
        this.caseUpdate = false;
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      saveCase() {
        if (this.caseUpdate) {
          var index = this.$store.getters['case/active'];
          this.$store.commit('case/edit', index);
        }
        else
          this.$store.commit('case/add');

        this.$store.commit('case/clear');
        this.addCaseDialog = false;
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      removeCase() {
        this.$store.commit('case/remove');
        this.addCaseDialog = false;
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      show () {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      },

      /* ########################################### METHODS SEPARATOR ########################################### */

      format_case_history(case_history) {

        console.log('case history', case_history);
        if (case_history == null) {
          return [];
        }
  
        var filteredCases = [];

        if(case_history) {
          case_history.forEach(function (caseInstance) {
            if(caseInstance.status == "submitted") {
              filteredCases.push(caseInstance);
            }
          });

          let patientCases = filteredCases.map(c => {
            
            for (let i = 0; i < c.case.examinations.length; i++) {
              c.case.examinations[i].sub_name = JSON.parse(c.case.examinations[i].sub_name);
            }


            let latest_request = null;

            console.log("latest request raw");
            console.log(c.latest_request);

            if(c.latest_request.length > 0) {
              latest_request = JSON.parse(JSON.stringify(c.latest_request[0]));
              latest_request.laboratory_tests = JSON.parse(latest_request.laboratory_tests);

              var initial_careplan = null;
              var initial_lab = null;
              var initial_medcert = null;
              var initial_prescription = null;

              /* ################################### GETTING THE FILENAMES ONLY ################################### */

              if(latest_request.file_careplan != null) {
                initial_careplan = latest_request.file_careplan.split("/");
                latest_request.file_careplan =  this.VUE_APP_API_URL + "/case/consultations/request/" + initial_careplan[initial_careplan.length - 1] + "?auth_token="+this.auth_token;
              }

              if(latest_request.file_laboratory != null) {
                initial_lab = latest_request.file_laboratory.split("/");
                latest_request.file_laboratory =  this.VUE_APP_API_URL + "/case/consultations/request/" + initial_lab[initial_lab.length - 1] + "?auth_token="+this.auth_token;
              }

              if(latest_request.file_medical_certificate != null) {
                initial_medcert = latest_request.file_medical_certificate.split("/");
                latest_request.file_medical_certificate =  this.VUE_APP_API_URL + "/case/consultations/request/" + initial_medcert[initial_medcert.length - 1] + "?auth_token="+this.auth_token;
              }

              if(latest_request.file_prescription != null) {
                initial_prescription = latest_request.file_prescription.split("/");
                latest_request.file_prescription =  this.VUE_APP_API_URL + "/case/consultations/request/" + initial_prescription[initial_prescription.length - 1] + "?auth_token="+this.auth_token;
              }

              /* ################################### GETTING THE FILENAMES ONLY ################################### */
            }
            
            let doctor_email = null;
            if(c.doctor !== null) {
              doctor_email = c.doctor.email;
            }

            let case_notes_length = 0;
            let case_note_instance = null;
            console.log("case notes raw");
            console.log(c.case.notes);
            if(c.case.notes != null) {
              case_note_instance = JSON.parse(c.case.notes);
              console.log("case notes");
              console.log(case_note_instance);
              case_notes_length = case_note_instance.length;
            }

            console.log("case medicines");
            console.log(c.case.medicines);
            console.log("case_id :"+c.id);

            let filtered_diagnoses = c.case.diagnoses.filter(diagnosis => diagnosis.case_consultation_id == c.id);
            let filtered_recommendations = c.case.recommendations.filter(recommendations => recommendations.case_consultation_id == c.id);
            let filtered_medicines = c.case.medicines.filter(medicines => medicines.case_consultation_id == c.id);

            return {
              id: c.id,
              historyOfPresentIllness: c.case.historyOfPresentIllness,
              impression: c.case.diagnoses.length ? c.case.diagnoses[0].impression : 'N⁄A',
              isSeasonalIllness: c.case.isSeasonalIllness,
              physician: doctor_email,
              health_concern: c.case.health_concern,
              case_category: c.case.case_category,
              case_number: c.case_number,
              created_at: moment(c.created_at).format('MM⁄DD⁄YYYY'),
              reason_for_encounter: c.case.reason_for_encounter,
              examinations: c.case.examinations,
              total_examinations: c.case.examinations.length,
              diagnoses: filtered_diagnoses,
              total_diagnoses: filtered_diagnoses.length,
              medicines: filtered_medicines,
              total_medicines: filtered_medicines.length,
              recommendations: filtered_recommendations,
              total_recommendations: filtered_recommendations.length,
              notes: JSON.parse(c.case.notes),
              total_notes: case_notes_length,
              latest_request,
              /*documents: c.documents,
              total_documents: c.documents.length,*/
              case_images: [],
              case_images_pulled: false,
            }
          });

          this.patientCases = patientCases;
          console.log('[case-history]', this.patientCases)
        }
      },
    }
  }
</script>

<style lang="scss">
  .clickable { cursor: pointer; }
  .inline-block { display: inline-block; }

  .text-enlarge { font-size: 25px; padding-top: 25px; }
  .text-enlarge label { margin-top: -10px; }

  #health-concern { position:relative; width: fit-content; }
  .case-title-action {
    position: absolute;
    right: -45px;
    top: -19px;
    background: #555;
    color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
  }

  .case-title-action .v-icon {
    color: #fff;
    margin-top: -10px;
  }

  .images-wrapper .image {
    cursor: pointer;
    margin-right: 10px;
    display: inline-block;
    width: 150px;
    height: 150px;
    -o-object-fit: cover;
    object-fit: 100%;
    background-size: 100%;
    background-position: center;
  }

  .pdf-image-ico {
    width: 50px;
    padding: 5px;
  }

  .image {
    cursor: pointer;
    margin-right: 10px;
    display: inline-block;
    width:200px;
    height:200px;
    object-fit:cover;
  }

  .capitalize { text-transform: capitalize; }

  .blue-button {
    background-color: #258bf5;
    border-radius: 15px;
    padding: 5px 15px;
    color: #fff;
    font-size: 12px;
    width: 100%;
    right: 0;
    top: -45px;
    font-weight: 700;
    cursor: pointer;
    text-align: center;
  }

  .case-image-preview {
    position: relative;
    margin-bottom: 30px;
  }

  .case-image-datetime {
    position: absolute;
    bottom: -23px;
    font-size: 10px;
    width: 100%;
    text-align: center;
  }
</style>